import {
  graphql,
  type ResultOf,
  type VariablesOf,
} from "@/data-access/graphql";
import { OffsetPaginationInfoFragment } from "@/data-access/shared/fragments/feed-article-projection-fragments";

export const GetBriefingsTable = graphql(
  `
    query getBriefingsTable(
      $filters: BriefingTableFilter
      $ordering: [BriefingTableOrder!]
      $pagination: OffsetPaginationInput
    ) {
      briefings(
        filters: $filters
        ordering: $ordering
        pagination: $pagination
      ) {
        allCount
        needsReviewCount
        activeCount
        pausedCount
        scheduledCount
        totalCount
        pageInfo {
          ...OffsetPaginationInfoFragment
        }
        results {
          id
          name
          description
          status
          needsReview
          recipients
          sendOn
          sendAt
          timezone
          lastRunDate
          lastRunStatus
          updatedAt
          updatedBy {
            id
            name
            email
          }
          template {
            id
            name
          }
        }
      }
    }
  `,
  [OffsetPaginationInfoFragment],
);

export type GetBriefingsTableResult = ResultOf<typeof GetBriefingsTable>;

export type GetBriefingsTableVariables = VariablesOf<typeof GetBriefingsTable>;

export type BriefingTableRow =
  GetBriefingsTableResult["briefings"]["results"][number];

export type BriefingTableTabCounts = Pick<
  GetBriefingsTableResult["briefings"],
  | "allCount"
  | "needsReviewCount"
  | "activeCount"
  | "pausedCount"
  | "scheduledCount"
>;

export type BriefingTableOrdering = NonNullable<
  GetBriefingsTableVariables["ordering"]
>[number];
